import React from "react";
import Login from "../../components/login";
import { login_sso } from "../../store/actions/sso";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const SsoView = ({setFirstLogin}) => {
  const location = useLocation();
  const auth = useSelector(state => state.auth);
  const sso = useSelector(state => state.sso);
  return (
    <div>
      <Login auth={auth} login_sso={login_sso} location={location} sso={sso} setFirstLogin={setFirstLogin}/>
    </div>
  );
};

export default SsoView;
